module.exports = __webpack_public_path__ + "img/back.e16625e0.svg";